let breakpoints = [1800, 1050, 800, 600, 400, 0]
let breakpointsName = ['hd', 'medium', 'desktop', 'tablet', 'xs-tablet', 'mobile']

export default {
  detect: (w) => {
    let lastSize = 0
    let done = false
    breakpoints = breakpoints.sort(function (a, b) {
      return (b - a)
    })

    for (let bp in breakpoints) {
      if (w >= breakpoints[bp] && w < breakpoints[bp - 1]) {
        switch (breakpoints[bp]) {
          case 0:
            return 'mobile'
          case 400:
            return 'xs-tablet'
          case 600:
          case 800:
            return 'tablet'
          case 1050:
            return 'desktop'
          case 1800:
            return 'hd'
        }
      }
    }

    if (w >= breakpoints[0]) {
      return 'hd'
    }
  },

  isSmallerThan (width, breakpoint, equals = true) {
    let index = breakpointsName.indexOf(breakpoint)

    if (equals) {
      return (width <= breakpoints[index])
    } else {
      return (width < breakpoints[index])
    }
  },

  isBiggerThan (width, breakpoint, equals = true) {
    let index = breakpointsName.indexOf(breakpoint)

    if (equals) {
      return (width >= breakpoints[index])
    } else {
      return (width > breakpoints[index])
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/Breakpoints.js
 **/